import { render } from "./person-military-delete.vue?vue&type=template&id=52a0ca51"
import script from "./person-military-delete.vue?vue&type=script&lang=js"
export * from "./person-military-delete.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__